/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'ui-header',
    template: require('./ui-header.html'),
    styles: [require('./ui-header.less')],
})

export class UiHeader {

    @Input() public caption: string;
    @Input() public captionLabel: string;
    @Input() public iconTitle: boolean;

    @Output('iconAction') public iconEmitter: EventEmitter<any> = new EventEmitter();

    iconAction($event) {
        this.iconEmitter.emit($event)
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-header/ui-header.ts